var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"HeaderMobileNav hide--reciteme-and-up"},[_c('a',{staticClass:"HeaderMobileNav__search",attrs:{"href":"/search"}},[_c('BaseIcon',{attrs:{"icon":"search-icon"}})],1),_vm._v(" "),_c('NavToggle',{on:{"toggle":_vm.toggle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }